import { Badge, Typography } from '@prenuvo/halo';

import { USER_PREFERENCE_KEY, UserPreference } from '@/api/model';

interface PreferenceLabelProps {
  preference: UserPreference;
}

export function PreferenceLabel({ preference }: PreferenceLabelProps) {
  if (preference.key === USER_PREFERENCE_KEY.SHOW_REQUIRED_ACTIONS_UPFRONT) {
    const alertIconInjectionPoint = 'Show ';
    const splitIndex = preference.name.indexOf(alertIconInjectionPoint);

    if (splitIndex !== -1) {
      return (
        <Typography
          as="span"
          className="text-neutral-400 dark:text-neutral-400"
          translationKey="FCT.REPORTING.HEADER.PREFERENCES.LABELS.SHOW_REQUIRED_ACTIONS_UPFRONT"
          values={{
            alertIcon: <Badge className="inline-flex bg-red-500" value="!" />,
            name: preference.name,
          }}
          variant="paragraph-sm"
        />
      );
    }
  }

  return (
    <Typography
      as="span"
      className="text-neutral-400 dark:text-neutral-400"
      translationKey="FCT.REPORTING.HEADER.PREFERENCES.LABELS.DEFAULT"
      values={{
        name: preference.name,
      }}
      variant="paragraph-sm"
    />
  );
}
